(function (
	global,
	$,
	moduleRegistrar,
	Module,
	Slider,
	ImageHelper,
	undefined
) {
	/**
	 * webSCAPE lightbox class.
	 */
	class Lightbox extends Slider
	{
		/**
		 * @inheritDoc
		 */
		constructor(id = null, options = {})
		{
			super(id, options);

			// Slide image sizes attribute.
			this.imageSizes =
				'(min-width: 1681px) 1280px, (min-width: 1281px) 960px, '+
				'(min-width: 961px) 768px, (min-width: 769px) 640px, '+
				'(min-width: 481px) 480px, 320px';

			// Gallery the lightbox is currently attached to.
			this.currentGallery = null;

			// Number of slides to show.
			this.options.showItems = 1;

			/**
			 * CSS ids.
			 *
			 * @type  {object}
			 * @since 1.0.0
			 */
			this.ids = {
				container: 'webscape-lightbox',
			};

			/**
			 * CSS classes.
			 *
			 * @type  {object}
			 * @since 1.0.0
			 */
			this.classes.container = 'webscape-lightbox';

			/**
			 * Element selectors.
			 *
			 * @type  {object}
			 * @since 1.0.0
			 */
			this.selectors = {
				active: '.' + this.classes.active,
				prev: '.' + this.classes.prev,
				next: '.' + this.classes.next,
				container: '[data-js="lightbox"]',
				navigation: '[data-js~="slider-nav"]',
				navigationPrev: '[data-js~="slider-prev"]',
				navigationNext: '[data-js~="slider-next"]',
				indicator: '[data-js="lightbox-indicator"]',
				slidesContainer: '[data-js="lightbox-items"]',
				slide: '[data-js~="lightbox-item"]',
				loadingSpinner: '[data-js="lightbox-loading"]',
				lightboxClose: '[data-js="lightbox-close"]',
				galleryContainer: '[data-lightbox="true"]',
				galleryItem: '.js-gallery-item',
			};

			this.slideIndex = 0;

			// Initialize the slider.
			this.initSlider();
		}

		/**
		 * @inheritDoc
		 */
		initSlider()
		{
			// Abort if lightbox exists already.
			if ($(this.selectors.container).length || ! $(this.selectors.galleryContainer).length) {
				return;
			}

			// Create lightbox HTML.
			this.createLightboxHtml();

			// Add click event handler to every gallery image.
			$(this.selectors.galleryContainer).each((index, gallery) => {
				$(gallery).find('img').on('click', e => {
					this.openLightbox($(e.currentTarget));
				});
			});

			// Set image attributes.
			this.setSlideImageProperties(this.getActiveSlide());
		}

		/**
		 * Creates the lightbox HTML.
		 *
		 * @since 1.0.0
		 */
		createLightboxHtml()
		{
			let lightboxHtml = document.createElement('div');
			document.body.appendChild(lightboxHtml);

			lightboxHtml.outerHTML = `<div id="${this.ids.container}" class="${this.classes.container}" data-js="lightbox" data-transition="${this.options.transition}" data-navigation="${this.options.navigation}">
				<div class="webscape-lightbox__items" data-js="lightbox-items"></div>
				<div class="webscape-lightbox__navigation left">
					<div class="webscape-lightbox__navigation-button left" data-js="slider-nav slider-prev"></div>
				</div>
				<div class="webscape-lightbox__navigation right">
					<div class="webscape-lightbox__navigation-button right" data-js="slider-nav slider-next"></div>
				</div>
				<div class="webscape-lightbox__close">
					<div class="webscape-lightbox__close-button" data-js="lightbox-close"></div>
				</div>
				<div class="webscape-lightbox__loading" data-js="lightbox-loading">
					<span></span>
					<span></span>
					<span></span>
					<span></span>
				</div>
			</div>`;

			this.container = $(this.selectors.container);
		}

		/**
		 * Sets image src, srcset, sizes, width, and height.
		 *
		 * @param {jQuery} $slide
		 * @since 1.0.0
		 */
		setSlideImageProperties($slide)
		{
			// Get image of slide.
			let $slideImage = $slide.find('img');

			if (! $slideImage.length) {
				return;
			}

			// Set src, srcset, and sizes attributes.
			$slideImage.attr('src', $slideImage.attr('data-src'));
			$slideImage.attr('srcset', $slideImage.attr('data-srcset'));
			$slideImage.attr('sizes', this.imageSizes);

			let windowHeight = window.innerHeight || document.documentElement.clientHeight;
			let windowWidth = window.innerWidth || document.documentElement.clientWidth;

			// Set image width and height when loaded.
			new ImageHelper($slideImage.attr('src'))
				.isLoaded().then(img => {
				if (windowWidth * 0.8 * img.getHeight() / img.getWidth() > windowHeight * 0.85) {
					$slideImage.css('width', 'auto');
					$slideImage.css('height', '80vh');
				} else {
					$slideImage.css('width', '80vw');
					$slideImage.css('height', 'auto');
				}
			}).catch(err => console.error(err));
		}

		/**
		 * Opens the lightbox.
		 *
		 * @param {object} target
		 * @since 1.0.0
		 */
		openLightbox(target)
		{
			let $galleryContainer = $(target).closest(this.selectors.galleryContainer);

			// Add images to lightbox the first time the lightbox is opened for a gallery.
			if (! $galleryContainer.attr('id') || this.currentGallery !== $galleryContainer.attr('id')) {
				$(this.selectors.slidesContainer).html(this.createLightboxSlidesHtml($galleryContainer));
			}

			// Set current gallery.
			this.currentGallery = $galleryContainer.attr('id');

			// Call initialization from parent.
			super.initSlider();

			// Reset active slide.
			this.getAllSlides().removeClass(this.classes.active);

			// Get image index.
			this.slideIndex = $(target).data('index');

			// Set lightbox slide to active by index.
			this.container.find(this.selectors.slide + '[data-index="' + this.slideIndex + '"]').addClass(this.classes.active);

			// Move last liste before fist to allow infinite slide show.
			this.getFirstSlide(true).before(this.getLastSlide(true));

			// Set image attributes.
			this.setSlideImageProperties(this.getActiveSlide());

			// Show lightbox.
			this.container.addClass(this.classes.active);

			if (! this.getActiveSlide(true).find('img').length) {
				return;
			}

			$(this.selectors.container).on('webscape_slider_before_set_slide', (e, data) => {
				// Set image attributes.
				this.setSlideImageProperties(data.slide);
			});

			// Check if image is loaded.
			new ImageHelper(this.getActiveSlide(true).find('img').attr('src'))
				.isLoaded().then(() => {
				// Remove loading animation.
				this.loadingAnimation.removeClass(this.classes.active);
			}).catch(err => console.error(err));
		}

		/**
		 * Create the lightbox slides HTML from the given gallery.
		 *
		 * @param 	{jQuery} $galleryContainer
		 * @returns {string}
		 * @since 	1.0.0
		 */
		createLightboxSlidesHtml($galleryContainer)
		{
			let lightboxImageHtml = '';

			$galleryContainer.find('img').each((index, image) => {
				lightboxImageHtml +=
					`<div class="webscape-lightbox__slide" data-js="lightbox-item" data-index="${index}">
						<div class="webscape-lightbox__image-container">
							<img class="webscape-lightbox__image" data-src="${$(image).attr('src') }" data-srcset="${$(image).attr('srcset')}" />
						</div>
					 </div>`;

				$(image).attr('data-index', index);
			});

			return lightboxImageHtml;
		}

		/**
		 * Closes the lightbox.
		 *
		 * @since 1.0.0
		 */
		closeLightbox()
		{
			this.container.removeClass(this.classes.active);
			this.getAllSlides().removeClass(this.classes.active);

			$(this.selectors.container).off('webscape_slider_before_set_slide');
		}

		/**
		 * @inheritDoc
		 */
		clickEvents(e, _this)
		{
			let target = e.target;

			if ($(target)[0] === $(_this.selectors.lightboxClose)[0]) {
				_this.closeLightbox();
				return;
			}

			return super.clickEvents(e, _this);
		}
	}

	moduleRegistrar.register(new Module('webscape-lightbox', Lightbox));

	$(document).ready(function () {
		new Lightbox();
	});
}) (
	window,
	jQuery,
	window.webSCAPE.moduleRegistrar,
	window.webSCAPE.Module,
	window.webSCAPE.moduleRegistrar.getModule('webscape-slider').getClass(),
	window.webSCAPE.moduleRegistrar.getModule('webscape-image-helper').getClass()
);
